export enum DashboardV2Events {
  dashboardViewed = 'Dashboard V2 Viewed',
  viewingProviderChanged = 'Dashboard V2 Viewing Provider Changed',
  alertReviewed = 'Dashboard V2 Alert Reviewed',
  alertTookAction = 'Dashboard V2 Alert Took Action',
  alertDismissed = 'Dashboard V2 Alert Dismissed',
  prepForSessionOpened = 'Dashboard V2 Prep For Session Opened',
}

export enum DashboardV2EventProps {
  ViewingMode = 'Viewing Mode',
  SignalType = 'Signal Type',
  DismissReason = 'Dismiss Reason',
}

export enum DashboardV2ViewingMode {
  SELF = 'Self',
  SUPERVISOR = 'Supervisor',
}
